export default "__VITE_ASSET__D2YDFOV2__"